/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Holder
 */
export interface Holder {
    /**
     * 
     * @type {string}
     * @memberof Holder
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof Holder
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof Holder
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof Holder
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof Holder
     */
    mobile?: string;
    /**
     * 
     * @type {string}
     * @memberof Holder
     */
    workPhone?: string;
}

/**
 * Check if a given object implements the Holder interface.
 */
export function instanceOfHolder(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function HolderFromJSON(json: any): Holder {
    return HolderFromJSONTyped(json, false);
}

export function HolderFromJSONTyped(json: any, ignoreDiscriminator: boolean): Holder {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'mobile': !exists(json, 'mobile') ? undefined : json['mobile'],
        'workPhone': !exists(json, 'workPhone') ? undefined : json['workPhone'],
    };
}

export function HolderToJSON(value?: Holder | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'firstName': value.firstName,
        'lastName': value.lastName,
        'email': value.email,
        'phone': value.phone,
        'mobile': value.mobile,
        'workPhone': value.workPhone,
    };
}

